module.exports = __webpack_public_path__ + "img/stamp-disconnected.f2c2a327.png";